var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-collapse',{staticClass:"user-collapse-hint border-rounded",attrs:{"visible":_vm.visible}},[_c('div',{staticClass:"padder"}),_c('span',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"padder"})])}
var staticRenderFns = []

export { render, staticRenderFns }